import React from 'react'
import Tag from '@ublique/components/Tags'
import '../../index.scss'

const TagContainer = (props) => {
  const { tagList = [], t, onRemoveTag } = props

  return (
    <>
      {tagList.map((col, idx) => (
        <Tag
          key={idx}
          column={col.id}
          title={t('Clear Filter')}
          className='tag-ublique-item'
          filter
          onClick={onRemoveTag}
        >
          {col.label}
        </Tag>
      ))}
    </>
  )
}

export default TagContainer
